import React from 'react';
import { Box, Typography, Grid, Card, CardContent, CardMedia } from '@mui/material';
import { Helmet } from 'react-helmet-async';

const Events = () => {
  const events = [
    {
      title: 'Coming Event',
      date: 'TBD',
      description: 'Upcoming event details to be announced.',
      image: '/events/Coming.png',
      category: 'Upcoming',
    },
    {
      title: 'Mirmire Sandya',
      date: 'Past Event Date',
      description: 'Description of the past event.',
      image: '/events/Mirmire Sandya Poster.jpeg',
      category: 'Past',
    },
    {
      title: 'Manoj Aryal Memorial Cup',
      date: 'Past Event Date',
      description: 'Description of the past event.',
      image: '/events/MAMC IG POST.png',
      category: 'Past',
    },
    {
      title: 'FPL Template',
      date: 'Past Event Date',
      description: 'Description of the past event.',
      image: '/events/FPL Template 2.png',
      category: 'Past',
    },
    {
      title: 'FIFA 24 in 2024',
      date: 'Past Event Date',
      description: 'Description of the past event.',
      image: '/events/FIFA 24 in 2024.jpg',
      category: 'Past',
    },
    {
      title: 'EURO PREDICTION FINAL',
      date: 'Past Event Date',
      description: 'Description of the past event.',
      image: '/events/EURO PREDICTION FINAL.png',
      category: 'Past',
    },
    {
      title: 'Draw Poster',
      date: 'Past Event Date',
      description: 'Description of the past event.',
      image: '/events/Draw poster.png',
      category: 'Past',
    },
  ];

  return (
    <>
      <Helmet>
        <title>Events - Mirmire</title>
        <meta name="description" content="Upcoming events at Mirmire" />
      </Helmet>

      {/* Header Section */}
      <Box
        sx={{
          bgcolor: '#000000',
          py: { xs: 6, md: 8 },
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          top: 0,
          zIndex: 1000,
        }}
      >
        <Typography
          variant="h1"
          sx={{
            color: '#FFD700',
            fontWeight: 700,
            fontSize: { xs: '2.5rem', md: '3.5rem' },
            textAlign: 'center',
          }}
        >
          EVENTS
        </Typography>
      </Box>

      {/* Events List Section */}
      <Box
        sx={{
          bgcolor: '#FFFFFF',
          py: { xs: 6, md: 8 },
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <Box
          sx={{
            width: '1000px',
            px: 2,
          }}
        >
          <Grid container spacing={4}>
            {events.map((event, index) => (
              <Grid item xs={12} key={index}>
                <Card
                  sx={{
                    display: 'flex',
                    flexDirection: { xs: 'column', md: 'row' },
                    bgcolor: '#000000',
                    color: '#FFFFFF',
                    overflow: 'hidden',
                    cursor: 'pointer',
                    transition: 'transform 0.3s ease-in-out',
                    '&:hover': {
                      transform: 'scale(1.05)',
                      boxShadow: '0 10px 20px rgba(0,0,0,0.3)',
                    },
                  }}
                >
                  <CardMedia
                    component="img"
                    sx={{
                      width: { xs: '100%', md: 300 },
                      height: { xs: 'auto', md: 'auto' },
                      maxHeight: { xs: 'none', md: 300 },
                      bgcolor: '#333333',
                      objectFit: { xs: 'cover', md: 'fill' },
                    }}
                    image={event.image}
                    alt={event.title}
                  />
                  <CardContent
                    sx={{
                      flex: 1,
                      p: 3,
                    }}
                  >
                    <Typography
                      variant="h4"
                      sx={{
                        color: '#FFD700',
                        fontWeight: 700,
                        mb: 1,
                      }}
                    >
                      {event.title}
                    </Typography>
                    <Typography
                      variant="subtitle1"
                      sx={{
                        color: '#FFD700',
                        mb: 2,
                      }}
                    >
                      {event.date}
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{
                        mb: 3,
                      }}
                    >
                      {event.description}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Box>
    </>
  );
};

export default Events;
